import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { TokensResponseSchema } from '../tokens';
export { ScramServerFirstDto as UserLoginServerFirstDto } from './scram';
export const UserLoginServerFinalSchema = TokensResponseSchema.extend({
    userId: z.string(),
    userEncryptedKey: z.string(),
    userEncryptedKeyGen: z.number(),
    userEncryptedKeySalt: z.string(),
    userEncryptedKeyIterations: z.number(),
});
export class UserLoginServerFinalDto extends createZodDto(UserLoginServerFinalSchema) {
}
